import { render } from "./DepotOrders.vue?vue&type=template&id=bcefbee6"
import script from "./DepotOrders.vue?vue&type=script&lang=js"
export * from "./DepotOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__